import { toast } from 'sonner';

const HUES = ['#22d3ee', '#a78bfa', '#34d399', '#fbbf24', '#f472b6', '#60a5fa'];

/**
 * A small, dependency-free celebration. Fires from the top of the viewport,
 * cleans up after itself, and pairs with one line of praise.
 */
export function celebrate(message, { pieces = 36 } = {}) {
  if (message) toast.success(message);
  if (typeof document === 'undefined') return;

  const layer = document.createElement('div');
  layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden';
  document.body.appendChild(layer);

  for (let i = 0; i < pieces; i += 1) {
    const bit = document.createElement('div');
    const hue = HUES[i % HUES.length];
    const left = Math.random() * 100;
    const delay = Math.random() * 220;
    const drift = (Math.random() - 0.5) * 220;
    const size = 6 + Math.random() * 7;
    bit.style.cssText = `position:absolute;top:-24px;left:${left}vw;width:${size}px;height:${size * 0.6}px;
      background:${hue};border-radius:2px;opacity:0.95;box-shadow:0 0 12px ${hue}99;`;
    bit.animate([
      { transform: 'translate3d(0,0,0) rotate(0deg)', opacity: 1 },
      { transform: `translate3d(${drift}px, 78vh, 0) rotate(${540 + Math.random() * 360}deg)`, opacity: 0 },
    ], { duration: 1500 + Math.random() * 900, delay, easing: 'cubic-bezier(.2,.6,.3,1)', fill: 'forwards' });
    layer.appendChild(bit);
  }

  setTimeout(() => layer.remove(), 2800);
}

export default celebrate;
